module.exports = __webpack_public_path__ + "static/50gde-fbd2ccb5ac68d3751cb9ac025ab60726.gif";